// @ts-check

export const SIZE = 9;
export const CELL_COUNT = 81;
export const ALL_CANDIDATES = 0x1ff;
export const DIGITS = Object.freeze([1, 2, 3, 4, 5, 6, 7, 8, 9]);
export const DIFFICULTIES = Object.freeze([
  "beginner",
  "easy",
  "medium",
  "hard",
]);

export const TECHNIQUE_WEIGHTS = Object.freeze({
  naked_single: 1,
  hidden_single: 2,
  locked_candidate: 3,
  naked_pair: 4,
  hidden_pair: 5,
  naked_triple: 6,
  hidden_triple: 7,
  x_wing: 8,
});

export const POPCOUNT = new Uint8Array(512);
for (let mask = 1; mask < POPCOUNT.length; mask += 1) {
  POPCOUNT[mask] = POPCOUNT[mask >> 1] + (mask & 1);
}

export function digitMask(digit) {
  return digit >= 1 && digit <= 9 ? 1 << (digit - 1) : 0;
}

export function maskDigits(mask) {
  return DIGITS.filter((digit) => mask & digitMask(digit));
}

export function singleDigit(mask) {
  return POPCOUNT[mask] === 1 ? Math.log2(mask) + 1 : 0;
}
